const TOKEN_KEY = 'accessToken';

export const setToken = (token: string | null) => {
  if (token) {
    localStorage.setItem(TOKEN_KEY, token);
  } else {
    localStorage.removeItem(TOKEN_KEY);
  }
};

export const getToken = (): string | null => {
  return localStorage.getItem(TOKEN_KEY);
};